<div>
  <div class="placeholder shimmer w-full" [style.height]="height"></div>
</div>
